import React, { useLayoutEffect, useRef, useState, useEffect } from 'react'
import styles from './search.m.scss'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import {
  getAuthors,
  getLead,
  getPublishingDate,
  getTeaserImgSrc,
  getTitle,
  getTitleHeader,
  getUpdatedDate
} from '@ta-interaktiv/api-access'

export const Search = ({ ids }) => {
  const input = useRef()
  const [articles, setArticles] = useState([])
  const [filteredArticles, setFilteredArticles] = useState([])
  const [showResult, setShowResult] = useState(false)
  const domain = parseHostname().publicationName

  const getArticleTeaserData = (
    domain: string,
    articleId: string | number
  ): Promise<ArticleTeaserData> => {
    return Promise.all([
      getAuthors(domain, articleId),
      getTeaserImgSrc(domain, articleId, '800px'),
      getLead(domain, articleId),
      getTitle(domain, articleId),
      getTitleHeader(domain, articleId),
      getPublishingDate(domain, articleId),
      getUpdatedDate(domain, articleId)
    ])
      .then(
        ([
          authors,
          teaserImgSrc,
          lead,
          title,
          titleHeader,
          publishingDateAsIsoString,
          updatedDateAsIsoString
        ]: [string[], string, string, string, string, string, string]) => {
          return {
            authors: authors.join(', '),
            imageSrc: teaserImgSrc,
            lead: lead ?? '',
            title: title ?? '',
            titleHeader: titleHeader,
            publishingDate: new Date(publishingDateAsIsoString).getTime(),
            updateDate: new Date(updatedDateAsIsoString).getTime(),
            id: articleId
          }
        }
      )
      .catch((e: Error) => {
        console.warn(
          `Article with ID ${articleId} could not be loaded, due to ${e.name}: ${e.message}`
        )
      })
  }

  const handleInputChange = value => {
    const userValue = value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()

    const result =
      value.length > 2
        ? [...articles.values()].filter(
            a =>
              a.title
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .indexOf(userValue) !== -1 ||
              a.lead
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .indexOf(userValue) !== -1
          )
        : []
    if (value.length > 2 && !showResult) {
      setShowResult(true)
    } else if (value.length <= 2) {
      setShowResult(false)
    }
    setFilteredArticles(result)
  }

  useLayoutEffect(() => {
    // input.current.focus()
  }, [])

  useEffect(() => {
    ids.forEach(articleId => {
      getArticleTeaserData(domain, articleId).then(
        (articleTeaserData: ArticleData) => {
          if (articleTeaserData) {
            setArticles(articles =>
              new Map(
                [...articles].sort((a, b) => b[1].updateDate - a[1].updateDate)
              ).set(articleId, articleTeaserData)
            )
          }
        }
      )
    })
  }, [ids])

  return (
    <div>
      <div className={styles.container}>
        {/* <div>Cherchez un mot-clé</div> */}
        <div className={styles.inputContainer}>
          <input
            className={styles.input}
            type='search'
            placeholder='Effectuez une recherche'
            ref={input}
            onChange={e => {
              handleInputChange(e.target.value)
            }}
          />
          <div className={styles.button}>
            {/* <span className={styles.checkmark} /> */}
            <i className='ui search icon' />
          </div>
        </div>
      </div>
      {showResult && (
        <>
          <div className={styles.resultLabel}>
            {filteredArticles.length === 0
              ? 'Aucun résultat'
              : filteredArticles.length +
                (' résultat' + (filteredArticles.length > 1 ? 's' : ''))}
          </div>
          <div>
            {filteredArticles.map((a, i) => (
              <div key={`result-item-${i}`} className={styles.item}>
                <img src={a.imageSrc} />
                <div>
                  <div>{a.title}</div>
                  <div className={styles.link}>
                    <a href={`https://www.${domain}.ch/${a.id}`}>
                      <i className='ui icon external alternate' /> Lire
                      l'article
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
